// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__32Dbw","colBig":"styles_colBig__2h7Jg","colSmall":"styles_colSmall__7grAk"};